import { InformationCircleIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

import { FEATURE_FLAGS, useFlag } from '~/components/feature-flags';

export const USAGE_BASED_FEATURES_NOTE =
  'Triggers, outbound voice, and Exhaustive analysis are available only on usage-based plans.';

/**
 * Plan comparison callout for the features reserved for usage-based billing.
 * It ships with the effort level selector because it is the first place
 * Exhaustive analysis is named outside the selector itself.
 */
export const UsageBasedFeaturesNote = ({ className }: { className?: string }) => {
  const shown = useFlag(FEATURE_FLAGS.EFFORT_LEVEL_SELECTOR);
  if (!shown) {
    return null;
  }
  return (
    <p
      className={clsx(
        'm-0 flex items-start gap-x-2 rounded-xl px-4 py-3 text-sm/6 text-neutral-600 ring-1 ring-neutral-200',
        'dark:bg-neutral-800/50 dark:text-neutral-400 dark:ring-white/15',
        className
      )}
    >
      <InformationCircleIcon
        aria-hidden="true"
        className="mt-0.5 size-5 flex-none text-primary-600 dark:text-primary-400"
      />
      {USAGE_BASED_FEATURES_NOTE}
    </p>
  );
};
